import React from 'react';
import PropTypes from 'prop-types';
import cloraLogo from '../../../../assets/images/logos/logo-clora-white.svg';

/* eslint-disable react/require-default-props */
function ProjectDetailsNav(_ref) {
  var displayExit = _ref.displayExit,
    _ref$reviewPath = _ref.reviewPath,
    reviewPath = _ref$reviewPath === void 0 ? null : _ref$reviewPath,
    homePath = _ref.homePath,
    _ref$isProjectNew = _ref.isProjectNew,
    isProjectNew = _ref$isProjectNew === void 0 ? false : _ref$isProjectNew,
    _ref$projectsPath = _ref.projectsPath,
    projectsPath = _ref$projectsPath === void 0 ? null : _ref$projectsPath;
  return /*#__PURE__*/React.createElement("nav", {
    className: "navbar project-questions navbar-expand navbar-dark navbar--teal style-guide p-0 mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container px-0"
  }, /*#__PURE__*/React.createElement("a", {
    href: homePath,
    className: "navbar-brand"
  }, /*#__PURE__*/React.createElement("img", {
    src: cloraLogo,
    alt: "Clora",
    id: "clf-nav-logo",
    height: 34,
    width: 80
  })), displayExit && /*#__PURE__*/React.createElement("ul", {
    className: "navbar-nav ms-auto"
  }, /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement("a", {
    href: isProjectNew ? projectsPath : reviewPath,
    className: "nav-link fw-semibold"
  }, "EXIT PROJECT QUESTIONS")))));
}
ProjectDetailsNav.propTypes = {
  isProjectNew: PropTypes.bool,
  displayExit: PropTypes.bool.isRequired,
  reviewPath: PropTypes.string,
  homePath: PropTypes.string.isRequired,
  projectsPath: PropTypes.string
};
export default ProjectDetailsNav;